// Public re-exports kept for backwards compatibility. The old monolithic
// Layout was replaced by the AppShell + TopBar + SideDrawer + BottomDock
// architecture. Permission helpers moved to /lib/accessControl.js.

import AppShell from './shell/AppShell';

export { hasViewAccess, hasEditAccess } from '../lib/accessControl';

export default AppShell;
